import {UniversalTable} from '@entities/components/universal-table/common.namespace';
import {ItemCommon} from '@entities/common/common.interface';
import {CTSDistributionColumns, CTSDistributionDateFilter} from './enums';
import {CtsTableFilters} from './cts-distribution.interfaces';

/** Auxiliary 'CTS_DISTRIBUTION_TABLE_COLUMNS' variable.' */
export const CTS_DISTRIBUTION_TABLE_COLUMNS: UniversalTable.BasicColumn[] = [
	{
		title: 'AMCN Id',
		width: '11rem',
		widthFr: 1.5,
		type: UniversalTable.ColumnType.String,
		id: CTSDistributionColumns.AmcnId,
		withSearch: true,
		sortable: true,
		draggable: true,
	},
	{
		title: 'Season AMCN Id',
		width: '13rem',
		widthFr: 1.5,
		type: UniversalTable.ColumnType.String,
		id: CTSDistributionColumns.SeasonAmcnId,
		withSearch: true,
		sortable: true,
		draggable: true,
	},
	{
		title: 'Series AMCN Id',
		width: '13rem',
		widthFr: 1.5,
		type: UniversalTable.ColumnType.String,
		id: CTSDistributionColumns.SeriesAmcnId,
		withSearch: true,
		sortable: true,
		draggable: true,
	},
	{
		title: 'Media AMCN Id',
		width: '13rem',
		widthFr: 1.5,
		type: UniversalTable.ColumnType.String,
		id: CTSDistributionColumns.MediaAmcnId,
		withSearch: true,
		sortable: true,
		draggable: true,
	},
	{
		title: 'Title',
		width: '24rem',
		widthFr: 3,
		type: UniversalTable.ColumnType.String,
		id: CTSDistributionColumns.Title,
		withSearch: true,
		sortable: true,
		draggable: true,
	},
	{
		title: 'Product Type',
		width: '14.5rem',
		widthFr: 1.5,
		type: UniversalTable.ColumnType.String,
		id: CTSDistributionColumns.ProductType,
		filterable: true,
		sortable: true,
		draggable: true,
	},
	{
		title: 'Press Target',
		width: '12rem',
		widthFr: 1.5,
		type: UniversalTable.ColumnType.String,
		id: CTSDistributionColumns.PressTarget,
		sortable: true,
		draggable: true,
	},
	{
		title: 'Platform',
		width: '18rem',
		widthFr: 1.5,
		type: UniversalTable.ColumnType.String,
		id: CTSDistributionColumns.Platform,
		filterable: true,
		sortable: true,
		draggable: true,
	},
	{
		title: 'Start Date',
		width: '17rem',
		widthFr: 1.5,
		type: UniversalTable.ColumnType.String,
		id: CTSDistributionColumns.StartDate,
		withDate: true,
		sortable: true,
		draggable: true,
	},
	{
		title: 'Content Id',
		width: '18rem',
		widthFr: 2,
		type: UniversalTable.ColumnType.Pattern,
		id: CTSDistributionColumns.ContentId,
		withSearch: true,
		editable: true,
		sortable: true,
		draggable: true,
	},
	{
		title: 'Variant Content Id',
		width: '18rem',
		widthFr: 2,
		type: UniversalTable.ColumnType.Pattern,
		id: CTSDistributionColumns.VariantContentId,
		withSearch: true,
		editable: true,
		sortable: true,
		draggable: true,
	},
	{
		title: 'Season Content Id',
		width: '18rem',
		widthFr: 2,
		type: UniversalTable.ColumnType.Pattern,
		id: CTSDistributionColumns.SeasonContentId,
		withSearch: true,
		editable: true,
		sortable: true,
		draggable: true,
	},
	{
		title: 'Series Content Id',
		width: '18rem',
		widthFr: 2,
		type: UniversalTable.ColumnType.Pattern,
		id: CTSDistributionColumns.SeriesContentId,
		withSearch: true,
		editable: true,
		sortable: true,
		draggable: true,
	},
	{
		title: 'Package Content Id',
		width: '18rem',
		widthFr: 2,
		type: UniversalTable.ColumnType.Pattern,
		id: CTSDistributionColumns.PackageContentId,
		withSearch: true,
		editable: true,
		sortable: true,
		draggable: true,
	},
	{
		title: 'Package Media Content Id',
		width: '18rem',
		widthFr: 2,
		type: UniversalTable.ColumnType.Pattern,
		id: CTSDistributionColumns.PackageMediaContentId,
		withSearch: true,
		editable: true,
		sortable: true,
		draggable: true,
	},
	{
		title: 'Package ADREF Content Id',
		width: '18rem',
		widthFr: 2,
		type: UniversalTable.ColumnType.Pattern,
		id: CTSDistributionColumns.PackageAdrefContentId,
		withSearch: true,
		editable: true,
		sortable: true,
		draggable: true,
	},
	{
		title: 'Package Movie Id',
		width: '18rem',
		widthFr: 2,
		type: UniversalTable.ColumnType.Pattern,
		id: CTSDistributionColumns.PackageMovieId,
		withSearch: true,
		editable: true,
		sortable: true,
		draggable: true,
	},
	{
		title: 'CTS Content Id',
		width: '18rem',
		widthFr: 2,
		type: UniversalTable.ColumnType.String,
		id: CTSDistributionColumns.CtsContentId,
		withSearch: true,
		sortable: true,
		draggable: true,
	},
	{
		title: 'CTS Series Content Id',
		width: '18rem',
		widthFr: 2,
		type: UniversalTable.ColumnType.String,
		id: CTSDistributionColumns.CtsSeriesContentId,
		withSearch: true,
		sortable: true,
		draggable: true,
	},
	{
		title: 'CTS Season Content Id',
		width: '18rem',
		widthFr: 2,
		type: UniversalTable.ColumnType.String,
		id: CTSDistributionColumns.CtsSeasonContentId,
		withSearch: true,
		sortable: true,
		draggable: true,
	},
	{
		title: 'CTS Package Content Id',
		width: '18rem',
		widthFr: 2,
		type: UniversalTable.ColumnType.String,
		id: CTSDistributionColumns.CtsPackageContentId,
		withSearch: true,
		sortable: true,
		draggable: true,
	},
	{
		title: 'CTS Package Movie Id',
		width: '18rem',
		widthFr: 2,
		type: UniversalTable.ColumnType.String,
		id: CTSDistributionColumns.CtsPackageMovieId,
		withSearch: true,
		sortable: true,
		draggable: true,
	},
	{
		title: 'CTS Partner Package Asset Id',
		width: '20rem',
		widthFr: 2,
		type: UniversalTable.ColumnType.String,
		id: CTSDistributionColumns.CtsPartnerPackageAssetId,
		withSearch: true,
		sortable: true,
		draggable: true,
	},
	{
		title: 'CTS Partner Package Title Id',
		width: '19.5rem',
		widthFr: 2,
		type: UniversalTable.ColumnType.String,
		id: CTSDistributionColumns.CtsPartnerPackageTitleId,
		withSearch: true,
		sortable: true,
		draggable: true,
	},
	{
		title: 'CTS Partner Package Media Id',
		width: '20.5rem',
		widthFr: 2,
		type: UniversalTable.ColumnType.String,
		id: CTSDistributionColumns.CtsPartnerPackageMediaId,
		withSearch: true,
		sortable: true,
		draggable: true,
	},
];

export const CTS_DISTRIBUTION_CHECKBOX_COLUMN_ID = 'checkbox';

/** Auxiliary 'CTS_DISTRIBUTION_CHECKBOX_COLUMN' variable.' */
export const CTS_DISTRIBUTION_CHECKBOX_COLUMN: UniversalTable.BasicColumn = {
	title: '',
	width: '3rem',
	type: UniversalTable.ColumnType.Pattern,
	id: CTS_DISTRIBUTION_CHECKBOX_COLUMN_ID,
};

/** Auxiliary 'CTS_EDIT_MODAL_CONTROLS' variable.' */
export const CTS_EDIT_MODAL_CONTROLS = {
	CONTENT_ID: 'contentId',
	SEASON_CONTENTID: 'seasonContentId',
	SERIES_CONTENTID: 'seriesContentId',
	PACKAGE_CONTENTID: 'packageContentId',
	PACKAGE_MEDIA_CONTENTD: 'packageMediaContentId',
	PACKAGE_ADREF_CONTENTID: 'packageAdrefContentId',
	PACKAGE_MOVIEID: 'packageMovieId',
	VARIANT_ID: 'variantId',
};

/** Auxiliary 'CTS_EDIT_MODAL_FIELDS' variable.' */
export const CTS_EDIT_MODAL_FIELDS: ItemCommon[] = [
	{
		id: CTS_EDIT_MODAL_CONTROLS.CONTENT_ID,
		name: 'Content Id',
	},
	{
		id: CTS_EDIT_MODAL_CONTROLS.VARIANT_ID,
		name: 'Variant Content Id',
	},
	{
		id: CTS_EDIT_MODAL_CONTROLS.SEASON_CONTENTID,
		name: 'Season Content Id',
	},
	{
		id: CTS_EDIT_MODAL_CONTROLS.SERIES_CONTENTID,
		name: 'Series Content Id',
	},
	{
		id: CTS_EDIT_MODAL_CONTROLS.PACKAGE_CONTENTID,
		name: 'Package Content Id',
	},
	{
		id: CTS_EDIT_MODAL_CONTROLS.PACKAGE_MEDIA_CONTENTD,
		name: 'Package Media Content Id',
	},
	{
		id: CTS_EDIT_MODAL_CONTROLS.PACKAGE_ADREF_CONTENTID,
		name: 'Package ADREF Content Id',
	},
	{
		id: CTS_EDIT_MODAL_CONTROLS.PACKAGE_MOVIEID,
		name: 'Package Movie Id',
	},
];

/** Auxiliary 'CTS_TABLE_INITIAL_FILTERS' variable.' */
export const CTS_TABLE_INITIAL_FILTERS = CTS_DISTRIBUTION_TABLE_COLUMNS.reduce((acc, col) => {
	if (col.withDate) {
		acc[CTSDistributionDateFilter.dateFrom] = null;
		acc[CTSDistributionDateFilter.dateTo] = null;
	}

	if (!col.withSearch && !col.filterable) {
		return acc;
	}

	return {...acc, [col.id]: col.filterable ? [] : null};
}, {}) as CtsTableFilters;

/** Auxiliary 'CTS_TABLE_SAVED_COLUMNS_KEY' variable.' */
export const CTS_TABLE_SAVED_COLUMNS_KEY = 'CTSColumns';
